export const TENANT_STORAGE_KEY = "storizone:tenant:v1";
export const TENANT_CHANGED_EVENT = "storizone:tenant:changed";

export function loadStoredTenant(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(TENANT_STORAGE_KEY) || null;
  } catch {
    return null;
  }
}

export function saveStoredTenant(id: string | null) {
  if (typeof window === "undefined") return;
  try {
    if (id) window.localStorage.setItem(TENANT_STORAGE_KEY, id);
    else window.localStorage.removeItem(TENANT_STORAGE_KEY);
  } catch {
    // ignore
  }
}

export function clearStoredTenant() {
  saveStoredTenant(null);
}
